import React, { Component } from 'react';
import Slider from 'react-slick';
import { Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from 'root/redux/selector/selector';
import { withRouter } from 'react-router-dom';
import MessagePopUp from 'root/components/MessagePopUp';
import Loading from 'root/components/Loading/Loading';
import SVGElements from 'root/components/SVGElements';

const GAME3D_RECOMMENDED_GAMES = [
    {
        id: 'KM-TABLE-017',
        imggame: '/public/html/games/images/s1/KM/KM-TABLE-017.jpg',
        text: 'Tai Xiu',
        imgprovider: '/public/html/images/provider_logo/icon-km.png',
        gameCode: 'KM-TABLE-017',
        provider: 'KM2',
        providerName: 'Kingmaker',
    },
    {
        id: 'KM-TABLE-023',
        imggame: '/public/html/games/images/s1/KM/KM-TABLE-023.jpg',
        text: 'Xoc Dia',
        imgprovider: '/public/html/images/provider_logo/icon-km.png',
        gameCode: 'KM-TABLE-023',
        provider: 'KM2',
        providerName: 'Kingmaker',
    },
    {
        id: 'KM-TABLE-014',
        imggame: '/public/html/games/images/s1/KM/KM-TABLE-014.jpg',
        text: 'Viet Fish Prawn Crab',
        imgprovider: '/public/html/images/provider_logo/icon-km.png',
        gameCode: 'KM-TABLE-014',
        provider: 'KM2',
        providerName: 'Kingmaker',
    },
    {
        id: 'KM-TABLE-015',
        imggame: '/public/html/games/images/s1/KM/KM-TABLE-015.jpg',
        text: 'Sic Bo',
        imgprovider: '/public/html/images/provider_logo/icon-km.png',
        gameCode: 'KM-TABLE-015',
        provider: 'KM2',
        providerName: 'Kingmaker',
    },
    {
        id: 'KM-TABLE-018',
        imggame: '/public/html/games/images/s1/KM/KM-TABLE-018.jpg',
        text: 'Keno',
        imgprovider: '/public/html/images/provider_logo/icon-km.png',
        gameCode: 'KM-TABLE-018',
        provider: 'KM2',
        providerName: 'Kingmaker',
    },
];

function SampleNextArrow(props) {
    const { style, onClick } = props;
    return (
        <div className='slick-next-btn' style={{ ...style }} onClick={onClick}>
            <i className='icon-arrow-big right'></i>
        </div>
    );
}
function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
        <div className='slick-prev-btn' style={{ ...style }} onClick={onClick}>
            <i className='icon-arrow-big left'></i>
        </div>
    );
}

class Recommended extends Component {
    isMount = true;
    constructor(props) {
        super(props);
        this.state = {
            detailModal: false,
            loginModal: false,
            msgTitle: '',
            hotGamesSlider: [],
            favoritedGame: [],
            loading: false,
            currentDomainPath: '',
        };
        this.toggleDetailModal = this.toggleDetailModal.bind(this);
    }

    toggleDetailModal = () => {
        this.setState({ detailModal: !this.state.detailModal, loginModal: false });
    };

    componentDidMount() {
        this.isMount = true;
        this.getHotGameSlider();
        this.setState({ currentDomainPath: this.props.history.location.pathname });
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    getMemberFavoriteGame = () => {
        const { screen, language } = this.props;

        let isMobile = null;
        if (screen.viewType === 'web') isMobile = false;
        else isMobile = true;

        let hotGame = this.state.hotGamesSlider;
        for (let a = 0; a < hotGame.length; a++) {
            hotGame[a].isFavourite = false;
        }
        window.SPL_Member.getMemberFavoriteGame(isMobile).then((data) => {
            let favGameList = data.favoritedGame;

            for (let k = 0; k < favGameList.length; k++) {
                for (let a = 0; a < hotGame.length; a++) {
                    if (favGameList[k].game === hotGame[a].gameCode) {
                        hotGame[a].isFavourite = true;
                        hotGame[a].id = favGameList[k].id;
                    }
                }
            }

            this.setState({ favoritedGame: favGameList, hotGamesSlider: hotGame });
        });

        let loadFavoriteGame = new Promise((resolve) => {
            window.SPL_Member.getMemberFavoriteGame(isMobile).then((data) => resolve(data));
        });

        let loadProviderGameMaintenanceList = new Promise((resolve) => {
            window.SPL_Provider.providerGameMaintenanceList(null, null, language.currencyLang).then((result) => resolve(result));
        });

        Promise.all([loadFavoriteGame, loadProviderGameMaintenanceList]).then((loadResult) => {
            let favGame = loadResult[0];
            let providerMaintenance = loadResult[1];

            for (let i = 0; i < favGame.favoritedGame.length; i++) {
                let provider = favGame.favoritedGame[i].provider;
                let providerGame = favGame.favoritedGame[i];

                if (!providerMaintenance) continue;
                for (let j = 0; j < providerMaintenance.length; j++) {
                    let maintenanceProvider = providerMaintenance[j].provider;

                    if (provider === maintenanceProvider) {
                        providerGame.underMaintenance = providerMaintenance[j];
                    }
                }
            }

            this.setState({ favoritedGame: favGame.favoritedGame }, () => {
                this.applyFavourite();
            });
        });
    };

    getThumbnailPath = (obj) => {
        const { slotThumbnail } = this.props.portal.settings;
        let path = obj.thumbnail;

        if (slotThumbnail) {
            if (path) path = '/public/html/games/images/' + slotThumbnail + '/' + obj.provider + '/' + obj.game + '.jpg';
        }

        return path;
    };

    updateMemberFavoriteGame = (game) => {
        this.setState({ loading: true });

        const { favoritedGame, currentDomainPath } = this.state;
        const { screen, user, history } = this.props;
        const { isLogin } = user;

        let isMobile = null;
        if (screen.viewType === 'web') isMobile = false;
        else isMobile = true;

        if (!isLogin) {
            if (isMobile) {
                history.push({ pathname: '/login', state: { currentDomainPath } });
            } else {
                this.setState({ detailModal: true, loginModal: true, loading: false }, () => {
                    this.loginMsg();
                });
            }
        } else {
            let deleteGame = false;
            for (let i = 0; i < favoritedGame.length; i++) {
                if (favoritedGame[i].game === game.gameCode) deleteGame = true;
            }

            if (deleteGame === true) {
                window.SPL_Member.deleteMemberFavoriteGame(game, isMobile).then(() => {
                    this.getMemberFavoriteGame();
                });
            } else {
                window.SPL_Member.updateMemberFavoriteGame(game, isMobile)
                    .then(() => {
                        this.getMemberFavoriteGame();
                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        }
    };

    deleteMemberFavoriteGame = (game) => {
        this.setState({ loading: true });

        const { currentDomainPath } = this.state;
        const { screen, user, history } = this.props;
        const { isLogin } = user;

        let isMobile = null;
        if (screen.viewType === 'web') isMobile = false;
        else isMobile = true;

        if (!isLogin) {
            if (isMobile) {
                history.push({ pathname: '/login', state: { currentDomainPath } });
            } else {
                this.setState({ detailModal: true, loginModal: true, loading: false }, () => {
                    this.loginMsg();
                });
            }
        } else {
            window.SPL_Member.deleteMemberFavoriteGame(game, isMobile).then(() => {
                this.getMemberFavoriteGame();
            });
        }
    };

    getHotGameSlider = () => {
        const { language, isGameCategory } = this.props;

        let loadFavoriteGame = new Promise((resolve) => {
            if (isGameCategory) resolve(GAME3D_RECOMMENDED_GAMES);
            else window.SPL_Content.getHotGameSlider().then((data) => resolve(data));
        });

        let loadProviderGameMaintenanceList = new Promise((resolve) => {
            window.SPL_Provider.providerGameMaintenanceList(null, null, language.currencyLang).then((result) => resolve(result));
        });

        Promise.all([loadFavoriteGame, loadProviderGameMaintenanceList]).then((loadResult) => {
            let hotGame = loadResult[0];
            let providerMaintenance = loadResult[1];

            for (let i = 0; i < hotGame.length; i++) {
                let provider = hotGame[i].provider;

                if (!providerMaintenance) continue;
                for (let j = 0; j < providerMaintenance.length; j++) {
                    let maintenanceProvider = providerMaintenance[j].provider;
                    if (provider === maintenanceProvider) {
                        hotGame[i].underMaintenance = providerMaintenance[j];
                    }
                }
            }

            if (this.isMount) {
                if (hotGame && hotGame.length > 0) {
                    this.setState({ hotGamesSlider: hotGame }, () => {
                        this.getMemberFavoriteGame();
                    });
                }
            }
        });
    };

    applyFavourite = () => {
        const { favoritedGame, hotGamesSlider } = this.state;
        for (let j = 0; j < hotGamesSlider.length; j++) {
            for (let i = 0; i < favoritedGame.length; i++) {
                if (favoritedGame[i].game === hotGamesSlider[j].gameCode) hotGamesSlider[j].isFavourite = true;
            }
        }

        this.setState({ hotGamesSlider: hotGamesSlider, loading: false });
    };

    launchGame = (gameObj, isFun, fav) => {
        const { language, screen, history, isGameCategory } = this.props;

        if (gameObj) {
            gameObj.category = isGameCategory ? 'G' : 'SL';
        }

        let params = null;
        if (fav) {
            params = {
                domain: window.location.hostname,
                isMobile: screen.isMobile,
                isFun: isFun,
                isMenuMode: !isFun,
                isMiniGame: false,
                languageKey: language.key,
                gameCode: gameObj.game,
                provider: gameObj.provider,
            };
        } else {
            params = {
                domain: window.location.hostname,
                isMobile: screen.isMobile,
                isFun: isFun,
                isMenuMode: !isFun,
                isMiniGame: false,
                languageKey: language.key,
                gameCode: gameObj.gameCode,
                provider: gameObj.provider,
            };
        }

        window.SPL_Provider.getIsEnabledWithouthAuth(gameObj, screen.viewType, params).then((isEnabled) => {
            const { isLogin } = this.props.user;
            if (!isLogin && !isEnabled) {
                if (this.isMount) {
                    if (screen.isMobile) {
                        history.push({ pathname: '/login', state: { currentDomainPath: this.state.currentDomainPath } });
                    } else {
                        this.setState({ detailModal: true, loginModal: true, loading: false }, () => {
                            this.loginMsg();
                        });
                    }
                }
            } else {
                window.SPL_Provider.generateGameUrl(gameObj, language, screen.viewType, params).then((url) => {
                    window.open(url, '_blank');
                });
            }
        });
    };

    checkMaintenance = (info, isFun, fav) => {
        const { history } = this.props;
        if (info.underMaintenance && info.underMaintenance.startTime) {
            history.push({
                pathname: '/maintenance',
                search: '?provider=' + info.name + '&startTime=' + info.underMaintenance.startTime + '&endTime=' + info.underMaintenance.endTime + '',
            });
        } else {
            this.launchGame(info, isFun, fav);
        }
    };

    loginMsg = () => {
        if (this.state.loginModal) {
            this.setState({ msgTitle: 'login:login.proceed' });
        }
    };

    render() {
        const { detailModal, loginModal, msgTitle, loading, favoritedGame, hotGamesSlider } = this.state;
        const { recommendSlideRow, history, searchKeyword, screen, isGameCategory } = this.props;

        const enableRecommendGame = this.props?.portal?.settings?.features?.enableRecommendGame?.includes(hotGamesSlider?.[0]?.category);
        let gameNameClass = 'gamename';
        if (enableRecommendGame) {
            gameNameClass = 'recommendgamename';
        }

        const isProviderPage = history.location.pathname.includes('/slots') || isGameCategory;

        var favourite = {
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 5,
            swipeToSlide: true,
            autoplay: false,
            autoplaySpeed: 1500,
            dots: true,
            pauseOnHover: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
        };

        var recomend = {
            infinite: true,
            slidesPerRow: recommendSlideRow,
            slidesToShow: 5,
            slidesToScroll: 5,
            swipeToSlide: true,
            autoplay: true,
            autoplaySpeed: 4000,
            dots: true,
            pauseOnHover: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        speed: 500,
                        slidesToShow: 3.5,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        variableWidth: false,
                        infinite: false,
                    },
                },
            ],
        };

        let modalMsg = {
            detailModal: detailModal,
            loginModal: loginModal,
            msgTitle: msgTitle,
            toggleDetailModal: this.toggleDetailModal,
        };

        const favGames = favoritedGame.map((info) => {
            return (
                <Translation key={info.id}>
                    {(t) => (
                        <ul className='nav-game'>
                            <li>
                                {info.hot && <i className='icon-tag icon-hot'></i>}
                                <img src={this.getThumbnailPath(info)} alt={info.id} />
                                <p>
                                    {!enableRecommendGame && <SVGElements className='icon-love-on' name='love-icon-on' />}
                                    <span className='gamename'>{info.name}</span>
                                    <span className={'icon-box ' + info.provider}>
                                        <i className={'icon-brand icon-' + info.provider}></i>
                                    </span>
                                </p>
                                <div className='hover-box'>
                                    <div className='img-box'>
                                        <img src={this.getThumbnailPath(info)} alt={info.id} />
                                        <div className='item-menu'>
                                            <span
                                                className='btn-normal'
                                                onClick={() => {
                                                    this.checkMaintenance(info, false, 'isFavourite');
                                                }}
                                            >
                                                {t('slot:slot.play', 'PLAY')}
                                            </span>

                                            {info.playForFun === true && (
                                                <span
                                                    className='btn-normal-green'
                                                    onClick={() => {
                                                        this.checkMaintenance(info, true, 'isFavourite');
                                                    }}
                                                >
                                                    {t('slot:slot.demo', 'DEMO')}
                                                </span>
                                            )}
                                            <div>
                                                <SVGElements className='icon-love-on' name='love-icon-on' onClick={() => this.deleteMemberFavoriteGame(info)} />
                                                <span>{t('home:home.addFavourite', 'Add To Favourite')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    )}
                </Translation>
            );
        });

        const hotGames = hotGamesSlider
            .filter((info) => {
                if (history.location.pathname.includes('/favourite')) {
                    if (searchKeyword === null) {
                        return info;
                    } else if (info.text.toLowerCase().includes(searchKeyword.toLowerCase())) {
                        return info;
                    }
                } else {
                    return info;
                }
            })
            .map((info) => {
                return (
                    <Translation key={info.id}>
                        {(t) => (
                            <ul className='nav-game'>
                                <li>
                                    {info.hot && <i className='icon-tag icon-hot'></i>}
                                    <img src={info.imggame} alt={info.id} />
                                    <p>
                                        {!enableRecommendGame && <SVGElements className='icon-love' name={info.isFavourite ? 'love-icon-on' : 'love-icon'} />}
                                        {/* <i className={`${info.isFavourite ? 'icon-love-on' : 'icon-love'}`}></i> */}
                                        <span className={gameNameClass}>{info.text}</span>
                                        <span className={'icon-box ' + info.provider}>
                                            <i className={'icon-brand icon-' + info.provider}></i>
                                        </span>
                                        {enableRecommendGame && (
                                            <img className='icon-provider-logo' src={`/public/html/images/provider_icon/${info.providerName}.png`} alt={info.id} />
                                        )}
                                    </p>
                                    <div className='hover-box'>
                                        <div className='img-box'>
                                            <img src={info.imggame} alt={info.id} />
                                            <div className='item-menu'>
                                                <span
                                                    className='btn-normal'
                                                    onClick={() => {
                                                        this.checkMaintenance(info, false);
                                                    }}
                                                >
                                                    {t('slot:slot.play', 'PLAY')}
                                                </span>

                                                {info.playForFun === true && (
                                                    <span
                                                        className='btn-normal-green'
                                                        onClick={() => {
                                                            this.checkMaintenance(info, true);
                                                        }}
                                                    >
                                                        {t('slot:slot.demo', 'DEMO')}
                                                    </span>
                                                )}
                                                <div>
                                                    <SVGElements
                                                        className='icon-love'
                                                        name={info.isFavourite ? 'love-icon-on' : 'love-icon'}
                                                        onClick={() => this.updateMemberFavoriteGame(info)}
                                                    />
                                                    {/* <i className={`${info.isFavourite ? 'icon-love-on' : 'icon-love'}`} onClick={() => this.updateMemberFavoriteGame(info)}></i> */}
                                                    <span>{t('home:home.addFavourite', 'Add To Favourite')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        )}
                    </Translation>
                );
            });

        return (
            <Translation>
                {(t) => (
                    <div>
                        {loading && <Loading />}
                        {detailModal && <MessagePopUp modalMsg={modalMsg} />}

                        {history.location.pathname === '/favourite' && (
                            <div className='content-bottom'>
                                <div className='content-top'>
                                    <span className='content-title'>{t('global:global.favouriteAdded', 'Added Favourite Games')}</span>
                                </div>
                                <div className='content-center-box'>
                                    <div
                                        className={`content-center bg-gray favourite-content ${!screen.isMobile && favGames.length <= 5 && 'favourite-flow'} 
                    ${screen.isMobile && (favGames.length <= 3 ? 'favourite-flow' : favGames.length > 3 && favGames.length <= 5 && 'special-cap')}`}
                                    >
                                        {!screen.isMobile && favGames.length > 5 ? (
                                            <Slider {...favourite} className='fade1'>
                                                {favGames}
                                            </Slider>
                                        ) : (favGames.length > 0 && favGames.length <= 5) || (screen.isMobile && favGames.length > 0) ? (
                                            favGames
                                        ) : (
                                            <div className='no-Matches'>{t('home:home.noFavGames', 'No Favourite Game Added')}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className={`content-top ${enableRecommendGame && screen.isMobile ? 'recommend-content-title' : ''}`}>
                            {history.location.pathname === '/favourite' ? (
                                <span className='content-title'>{t('global:global.dropGame', 'Dropping Like Its Hot Games')}</span>
                            ) : (
                                <span className='content-title'>{t('home:home.recommended', 'Recommended for you')}</span>
                            )}
                        </div>
                        <div className={`content-center-box ${enableRecommendGame && screen.isMobile ? 'recommend-content-top' : ''}`}>
                            <div
                                className={`content-center ${!screen.isMobile && hotGames.length <= 10 && 'favourite-flow'} 
                ${isProviderPage && hotGames.length > 5 && 'slot-special-cap'}
                ${screen.isMobile && (hotGames.length <= 3 ? 'favourite-flow' : hotGames.length > 3 && hotGames.length <= 10 && 'special-cap')}`}
                            >
                                {isProviderPage && hotGames.length > 5 ? (
                                    <Slider {...recomend} className='fade1'>
                                        {hotGames}
                                    </Slider>
                                ) : isProviderPage && hotGames.length > 0 && hotGames.length <= 5 ? (
                                    hotGames
                                ) : !screen.isMobile && hotGames.length > 10 ? (
                                    <Slider {...recomend} className='fade1'>
                                        {hotGames}
                                    </Slider>
                                ) : (hotGames.length > 0 && hotGames.length <= 10) || (screen.isMobile && hotGames.length > 0) ? (
                                    hotGames
                                ) : (
                                    <div className='no-Matches'>{t('home:home.noHotGames', 'Games not found, Please try again later')}</div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </Translation>
        );
    }
}

export default connect(mapStateToProps)(withTranslation()(withRouter(Recommended)));
